<div class="page">
  <div class="header">
    <!-- izquierda -->
    <div class="header-left">
      <button mat-icon-button (click)="cerrar()">
        <mat-icon>arrow_back</mat-icon>
      </button>

      <div>
        <div class="info">
          <h1>Gráficas de signos vitales</h1>

          <h2>
            {{ paciente.nombre }}
            {{ paciente.apellido }}
          </h2>
          <p>
            {{ obtenerEdad() }}
          </p>
          <p>Alergias: {{ paciente.expediente?.alergias || 'No registradas' }}</p>
          <p>No. expediente: {{ paciente.id }}</p>
        </div>
      </div>
    </div>

    <!-- derecha -->
    <div class="header-actions">
      <div>
        <button mat-flat-button class="add-boton" (click)="abrirRegistroSignosVitales()">
          Registrar signos vitales
          <mat-icon class="material-symbols-outlined"> heart_plus </mat-icon>
        </button>
      </div>

      <div>
        <button mat-icon-button [matMenuTriggerFor]="menu">
          <mat-icon>more_vert</mat-icon>
        </button>

        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="cambiarGrafica('peso')">Peso</button>

          <button mat-menu-item (click)="cambiarGrafica('glucosa')">Glucosa</button>

          <button mat-menu-item (click)="cambiarGrafica('presion')">Presión arterial</button>
        </mat-menu>
      </div>
    </div>
  </div>
  @if (hayDatosGrafica()) {
    <app-graficas
      [titulo]="titulo"
      [unidad]="unidad"
      [tipo]="tipo"
      [series]="series"
      [colores]="colores"
    >
    </app-graficas>

    @if (ultimaObservacion) {
      <div class="ultima-observacion">
        <div class="ultima-observacion-header">
          <mat-icon>notes</mat-icon>
          <span>Última observación</span>
        </div>

        <p>{{ ultimaObservacion || 'Sin observaciones' }}</p>
      </div>
    }
  } @else {
    <div class="sin-datos">
      <mat-icon>monitor_heart</mat-icon>

      <h2>No hay datos disponibles</h2>

      <p>
        No existen registros de {{ titulo.toLowerCase() }}
        para este paciente.
      </p>
    </div>
  }
</div>
